package org.multipaz.doctypes.generated

/**
 * Generated strings for language: ko
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_ko = mapOf(
    "age_verification_attribute_older_than_years" to "만 {age}세 초과",
    "age_verification_description_older_than_years" to "mDL 소지자의 {age}세 이상 여부",
    "age_verification_request_age_over_18" to "18세 이상",
    "age_verification_request_age_over_18_zkp" to "18세 이상 (ZKP)",
    "age_verification_request_age_over_21" to "21세 이상",
    "age_verification_request_age_over_21_zkp" to "21세 이상 (ZKP)",
    "age_verification_request_all_data_elements" to "모든 데이터 요소",
    "document_display_name_age_verification" to "연령 확인",
    "document_display_name_driving_license" to "운전면허증",
    "document_display_name_eu_personal_id" to "신분증",
    "document_display_name_google_wallet_id_pass" to "Google Wallet ID 패스",
    "document_display_name_photo_id" to "신분증",
    "document_display_name_vaccination_document" to "예방접종 증명서",
    "document_display_name_vehicle_registration" to "차량 등록증",
    "driving_license_attribute_aamva_version_number" to "AAMVA 버전 번호",
    "driving_license_attribute_administrative_number" to "관리 번호",
    "driving_license_attribute_age_in_years" to "나이(세)",
    "driving_license_attribute_alias_family_name" to "가명 성",
    "driving_license_attribute_alias_given_name" to "가명 이름",
    "driving_license_attribute_alias_suffix" to "가명 접미사",
    "driving_license_attribute_audit_information" to "감사 정보",
    "driving_license_attribute_biometric_template_face" to "생체 인식 얼굴 템플릿",
    "driving_license_attribute_biometric_template_fingerprint" to "생체 인식 지문 템플릿",
    "driving_license_attribute_biometric_template_iris" to "홍채 생체 인식 템플릿",
    "driving_license_attribute_biometric_template_signature_sign" to "생체 인식 서명 템플릿",
    "driving_license_attribute_compliance_type" to "규정 준수 유형",
    "driving_license_attribute_date_of_birth" to "생년월일",
    "driving_license_attribute_date_of_expiry" to "만료일",
    "driving_license_attribute_date_of_issue" to "발급일",
    "driving_license_attribute_domestic_driving_privileges" to "국내 운전 자격",
    "driving_license_attribute_driving_privileges" to "운전 권한",
    "driving_license_attribute_edl_indicator" to "EDL 지표",
    "driving_license_attribute_eye_color" to "눈 색깔",
    "driving_license_attribute_family_name" to "성",
    "driving_license_attribute_family_name_national_characters" to "성 (자국 문자)",
    "driving_license_attribute_family_name_truncation" to "성 생략",
    "driving_license_attribute_given_name_national_characters" to "이름 (자국 문자)",
    "driving_license_attribute_given_name_truncation" to "이름 생략",
    "driving_license_attribute_given_names" to "이름",
    "driving_license_attribute_hair_color" to "머리 색깔",
    "driving_license_attribute_hazmat_endorsement_expiration_date" to "위험물 취급 인가 만료일",
    "driving_license_attribute_height" to "신장",
    "driving_license_attribute_issuing_authority" to "발급 기관",
    "driving_license_attribute_issuing_country" to "발급 국가",
    "driving_license_attribute_issuing_jurisdiction" to "발급 관할 지역",
    "driving_license_attribute_license_number" to "면허 번호",
    "driving_license_attribute_limited_duration_document_indicator" to "기간 한정 문서 지표",
    "driving_license_attribute_name_suffix" to "이름 접미사",
    "driving_license_attribute_nationality" to "국적",
    "driving_license_attribute_older_than_13" to "만 13세 초과",
    "driving_license_attribute_older_than_16" to "만 16세 초과",
    "driving_license_attribute_older_than_18" to "만 18세 초과",
    "driving_license_attribute_older_than_21" to "만 21세 초과",
    "driving_license_attribute_older_than_25" to "만 25세 초과",
    "driving_license_attribute_older_than_60" to "만 60세 초과",
    "driving_license_attribute_older_than_62" to "만 62세 초과",
    "driving_license_attribute_older_than_65" to "65세 이상",
    "driving_license_attribute_older_than_68" to "68세 이상",
    "driving_license_attribute_organ_donor" to "장기 기증자",
    "driving_license_attribute_photo_of_holder" to "소지자 사진",
    "driving_license_attribute_place_of_birth" to "출생지",
    "driving_license_attribute_portrait_image_timestamp" to "증명사진 타임스탬프",
    "driving_license_attribute_race_ethnicity" to "인종/민족",
    "driving_license_attribute_resident_address" to "거주지 주소",
    "driving_license_attribute_resident_city" to "거주 도시",
    "driving_license_attribute_resident_country" to "거주 국가",
    "driving_license_attribute_resident_county" to "거주 카운티",
    "driving_license_attribute_resident_postal_code" to "거주 우편번호",
    "driving_license_attribute_resident_state" to "거주 주",
    "driving_license_attribute_sex" to "성별",
    "driving_license_attribute_signature_usual_mark" to "서명 / 일반적인 표시",
    "driving_license_attribute_un_distinguishing_sign" to "UN 식별 부호",
    "driving_license_attribute_veteran" to "재향 군인",
    "driving_license_attribute_weight" to "체중",
    "driving_license_attribute_weight_range" to "체중 범위",
    "driving_license_attribute_year_of_birth" to "출생 연도",
    "driving_license_description_aamva_version_number" to "AAMVA mDL 데이터 요소 세트의 버전을 식별하는 번호",
    "driving_license_description_administrative_number" to "발급 기관에서 할당한 감사 관리 번호.",
    "driving_license_description_age_in_years" to "mDL 소지자의 연령",
    "driving_license_description_alias_family_name" to "자격증 소지자가 알려진 다른 성.",
    "driving_license_description_alias_given_name" to "자격증 소지자가 알려진 다른 이름.",
    "driving_license_description_alias_suffix" to "자격증 소지자가 알려진 다른 접미사.",
    "driving_license_description_audit_information" to "자격 증명이 최초 발급된 시점, 장소, 발급자를 식별하는 문자 및/또는 숫자 문자열",
    "driving_license_description_biometric_template_face" to "mDL 소유자의 안면 생체 정보",
    "driving_license_description_biometric_template_fingerprint" to "mDL 소유자의 지문",
    "driving_license_description_biometric_template_iris" to "mDL 소유자의 홍채",
    "driving_license_description_biometric_template_signature_sign" to "mDL 소유자의 서명/사인",
    "driving_license_description_compliance_type" to "준수 여부를 나타내는 DHS 필수 필드.",
    "driving_license_description_date_of_birth" to "mDL 소지자의 생년월일. 알 수 없는 경우, 대략적인 생년월일",
    "driving_license_description_date_of_expiry" to "mDL 만료일",
    "driving_license_description_date_of_issue" to "mDL 발급일",
    "driving_license_description_domestic_driving_privileges" to "면허 소지자가 운전할 수 있는 차량 유형",
    "driving_license_description_driving_privileges" to "mDL 소지자의 운전 권한.",
    "driving_license_description_edl_indicator" to "자격증이 EDL인 경우 표시됨.",
    "driving_license_description_eye_color" to "mDL 소지자의 눈 색깔.",
    "driving_license_description_family_name" to "mDL 소지자의 성, 성씨 또는 주 식별자.",
    "driving_license_description_family_name_national_characters" to "mDL 소지자의 성",
    "driving_license_description_family_name_truncation" to "필드가 잘렸는지 여부를 나타내는 코드",
    "driving_license_description_given_name_national_characters" to "mDL 소지자의 이름",
    "driving_license_description_given_name_truncation" to "이름 또는 중간 이름이 잘렸는지 여부를 나타내는 코드",
    "driving_license_description_given_names" to "mDL 소지자의 이름, 다른 이름 또는 보조 식별자",
    "driving_license_description_hair_color" to "mDL 소지자의 머리 색상",
    "driving_license_description_hazmat_endorsement_expiration_date" to "문서에 의해 부여된 위험 물질 승인이 더 이상 유효하지 않은 날짜.",
    "driving_license_description_height" to "mDL 소지자의 신장(cm).",
    "driving_license_description_issuing_authority" to "발급 기관명.",
    "driving_license_description_issuing_country" to "발급 기관 국가 또는 지역의 ISO 3166-1에 정의된 Alpha-2 국가 코드",
    "driving_license_description_issuing_jurisdiction" to "mDL 발급 관할 구역의 국가 세분 코드",
    "driving_license_description_license_number" to "발급 기관에서 할당하거나 계산한 번호.",
    "driving_license_description_limited_duration_document_indicator" to "자격증 소지자의 임시 합법적 지위 여부를 나타내는 DHS 필수 필드. 1: 임시 합법적 지위.",
    "driving_license_description_name_suffix" to "운전면허증 또는 신분증이 발급된 개인의 이름 접미사",
    "driving_license_description_nationality" to "mDL 소지자의 국적",
    "driving_license_description_older_than_13" to "mDL 소지자의 13세 이상 여부",
    "driving_license_description_older_than_16" to "mDL 소지자의 16세 이상 여부",
    "driving_license_description_older_than_18" to "mDL 소지자의 18세 이상 여부",
    "driving_license_description_older_than_21" to "mDL 소지자의 21세 이상 여부",
    "driving_license_description_older_than_25" to "mDL 소지자의 25세 이상 여부 표시",
    "driving_license_description_older_than_60" to "mDL 소지자의 60세 이상 여부 표시",
    "driving_license_description_older_than_62" to "mDL 소지자의 62세 이상 여부 표시",
    "driving_license_description_older_than_65" to "mDL 소지자의 65세 이상 여부 표시",
    "driving_license_description_older_than_68" to "mDL 소지자의 68세 이상 여부 표시",
    "driving_license_description_organ_donor" to "자격 증명 소지자가 장기 기증자인지 여부를 나타내는 표시",
    "driving_license_description_photo_of_holder" to "mDL 소지자의 사진.",
    "driving_license_description_place_of_birth" to "mDL 소지자의 출생 국가, 시/도 또는 주/도",
    "driving_license_description_portrait_image_timestamp" to "인물 사진 촬영일",
    "driving_license_description_race_ethnicity" to "카드 소지자의 인종 또는 민족 코드.",
    "driving_license_description_resident_address" to "mDL 소지자의 거주 및 연락처 (도로명/번지수, 시/군/구 등)",
    "driving_license_description_resident_city" to "mDL 소지자의 거주 도시",
    "driving_license_description_resident_country" to "mDL 소지자가 거주하는 국가",
    "driving_license_description_resident_county" to "mDL 소지자가 거주하는 카운티의 3자리 카운티 코드.",
    "driving_license_description_resident_postal_code" to "mDL 소지자의 우편번호",
    "driving_license_description_resident_state" to "mDL 소지자의 거주 주/도/구역",
    "driving_license_description_sex" to "mDL 소지자의 성별.",
    "driving_license_description_signature_usual_mark" to "mDL 소지자의 서명 또는 통상적인 표식 이미지",
    "driving_license_description_un_distinguishing_sign" to "발급 국가의 식별 부호.",
    "driving_license_description_veteran" to "자격 증명 소지자가 참전 용사인지 여부를 나타내는 표시",
    "driving_license_description_weight" to "mDL 소지자의 체중(kg).",
    "driving_license_description_weight_range" to "카드 소지자의 대략적인 체중 범위.",
    "driving_license_description_year_of_birth" to "mDL 소지자의 출생 연도",
    "driving_license_request_age_over_18" to "만 18세 이상",
    "driving_license_request_age_over_18_and_portrait" to "만 18세 이상 + 인물 사진",
    "driving_license_request_age_over_18_and_portrait_equivalence" to "만 18세 이상 + 본인 사진 확인",
    "driving_license_request_age_over_18_and_portrait_or_portrait_equivalence" to "만 18세 이상 + (본인 사진 또는 본인 사진 확인)",
    "driving_license_request_age_over_18_zkp" to "만 18세 이상 (ZKP)",
    "driving_license_request_age_over_21" to "만 21세 이상",
    "driving_license_request_age_over_21_and_portrait" to "만 21세 이상 + 인물 사진",
    "driving_license_request_age_over_21_zkp" to "만 21세 이상 (ZKP)",
    "driving_license_request_all_data_elements" to "모든 데이터 요소",
    "driving_license_request_mandatory_data_elements" to "필수 데이터 요소",
    "driving_license_request_name_and_address_all_stored" to "이름 및 주소 (모두 저장됨)",
    "driving_license_request_name_and_address_partially_stored" to "이름 및 주소 (일부 저장됨)",
    "driving_license_request_us_transportation" to "미국 운송",
    "eu_personal_id_attribute_address" to "주소",
    "eu_personal_id_attribute_age_in_years" to "만 나이",
    "eu_personal_id_attribute_city_of_birth" to "출생 도시",
    "eu_personal_id_attribute_country_of_birth" to "출생 국가",
    "eu_personal_id_attribute_date_of_birth" to "생년월일",
    "eu_personal_id_attribute_date_of_expiry" to "만료일",
    "eu_personal_id_attribute_date_of_issue" to "발급일",
    "eu_personal_id_attribute_document_number" to "문서 번호",
    "eu_personal_id_attribute_email_address_of_holder" to "소지자 이메일 주소",
    "eu_personal_id_attribute_family_name" to "성",
    "eu_personal_id_attribute_family_name_at_birth" to "출생 시 성",
    "eu_personal_id_attribute_first_name_at_birth" to "출생 시 이름",
    "eu_personal_id_attribute_given_names" to "이름",
    "eu_personal_id_attribute_issuing_authority" to "발급 기관",
    "eu_personal_id_attribute_issuing_country" to "발급 국가",
    "eu_personal_id_attribute_issuing_jurisdiction" to "발급 관할",
    "eu_personal_id_attribute_mobile_phone_of_holder" to "소지자의 휴대폰",
    "eu_personal_id_attribute_nationality" to "국적",
    "eu_personal_id_attribute_older_than_18" to "만 18세 이상",
    "eu_personal_id_attribute_older_than_21" to "만 21세 이상",
    "eu_personal_id_attribute_older_than_age_attestations" to "연령 이상 증명",
    "eu_personal_id_attribute_personal_administrative_number" to "개인 관리 번호",
    "eu_personal_id_attribute_photo_of_holder" to "소지자 사진",
    "eu_personal_id_attribute_place_of_birth" to "출생지",
    "eu_personal_id_attribute_resident_address" to "거주지 주소",
    "eu_personal_id_attribute_resident_city" to "거주 도시",
    "eu_personal_id_attribute_resident_country" to "거주 국가",
    "eu_personal_id_attribute_resident_house_number" to "거주지 번지",
    "eu_personal_id_attribute_resident_postal_code" to "거주지 우편번호",
    "eu_personal_id_attribute_resident_state" to "거주 주/도",
    "eu_personal_id_attribute_resident_street" to "거주 도로명",
    "eu_personal_id_attribute_sex" to "성별",
    "eu_personal_id_attribute_state_of_birth" to "출생 주",
    "eu_personal_id_attribute_year_of_birth" to "출생 연도",
    "eu_personal_id_description_address" to "주소",
    "eu_personal_id_description_age_in_years" to "PID 소지자의 만 나이",
    "eu_personal_id_description_city_of_birth" to "PID 사용자가 태어난 지자체, 도시, 읍 또는 마을",
    "eu_personal_id_description_country_of_birth" to "ISO 3166-1에 명시된 알파-2 국가 코드로, PID 사용자가 태어난 국가",
    "eu_personal_id_description_date_of_birth" to "PID 소지자의 생년월일. 알 수 없는 경우, 대략적인 출생일.",
    "eu_personal_id_description_date_of_expiry" to "PID 만료 날짜(및 시간)",
    "eu_personal_id_description_date_of_issue" to "PID 발급 날짜(및 시간)",
    "eu_personal_id_description_document_number" to "PID 제공기관에서 부여한 PID 번호",
    "eu_personal_id_description_email_address_of_holder" to "개인 식별 데이터와 관련된 사용자 이메일 주소([RFC 5322] 준수)",
    "eu_personal_id_description_family_name" to "PID 소지자의 현재 성(姓) 또는 주요 식별자",
    "eu_personal_id_description_family_name_at_birth" to "PID 소지자의 출생 시 성 또는 주 식별자",
    "eu_personal_id_description_first_name_at_birth" to "PID 소지자의 출생 시 이름 또는 보조 식별자",
    "eu_personal_id_description_given_names" to "PID 소지자의 현재 이름 또는 보조 식별자",
    "eu_personal_id_description_issuing_authority" to "발급 기관명 또는 별도 발급 기관이 없는 경우 해당 회원국의 ISO 3166 Alpha-2 국가 코드",
    "eu_personal_id_description_issuing_country" to "발급 기관의 국가 또는 영토 Alpha-2 국가 코드(ISO 3166-1 정의)",
    "eu_personal_id_description_issuing_jurisdiction" to "발급 관할 구역의 국가 세부 분류 코드(ISO 3166-2:2020, 8항). 코드의 첫 부분은 issuing_country 값과 동일해야 합니다.",
    "eu_personal_id_description_mobile_phone_of_holder" to "개인 식별 데이터와 관련된 사용자 휴대폰 번호. 국제 코드 접두사 '+ 및 국가 코드로 시작하며 숫자만 포함합니다.",
    "eu_personal_id_description_nationality" to "PID 사용자의 국적을 나타내는 ISO 3166-1에 명시된 Alpha-2 국가 코드",
    "eu_personal_id_description_older_than_18" to "18세 이상?",
    "eu_personal_id_description_older_than_21" to "21세 이상?",
    "eu_personal_id_description_older_than_age_attestations" to "특정 연령 이상 증명",
    "eu_personal_id_description_personal_administrative_number" to "감사 또는 기타 목적으로 PID 제공기관이 부여한 번호",
    "eu_personal_id_description_photo_of_holder" to "PID 소지자의 인물 사진",
    "eu_personal_id_description_place_of_birth" to "PID 소지자가 태어난 국가 및 지자체 또는 주/도",
    "eu_personal_id_description_resident_address" to "PID 소지자가 현재 거주하거나 연락받을 수 있는 장소의 전체 주소 (도로명/번지, 시/군/구 등 포함)",
    "eu_personal_id_description_resident_city" to "PID 소지자가 현재 거주하는 도시",
    "eu_personal_id_description_resident_country" to "PID 사용자가 현재 거주하는 국가의 ISO 3166-1에 명시된 Alpha-2 국가 코드",
    "eu_personal_id_description_resident_house_number" to "PID 사용자가 현재 거주하는 번지 (접두사 또는 접미사 포함)",
    "eu_personal_id_description_resident_postal_code" to "PID 소지자가 현재 거주하는 장소의 우편번호",
    "eu_personal_id_description_resident_state" to "PID 사용자가 현재 거주하는 주, 성, 구 또는 지역",
    "eu_personal_id_description_resident_street" to "PID 사용자가 현재 거주하는 도로명",
    "eu_personal_id_description_sex" to "PID 소지자의 성별",
    "eu_personal_id_description_state_of_birth" to "PID 사용자가 태어난 주, 도, 구역 또는 지역",
    "eu_personal_id_description_year_of_birth" to "PID 소지자가 태어난 연도",
    "eu_personal_id_request_age_over_18" to "18세 이상",
    "eu_personal_id_request_age_over_18_and_portrait" to "18세 이상 + 사진",
    "eu_personal_id_request_age_over_18_and_portrait_equivalence" to "만 18세 이상 + 본인 사진 확인",
    "eu_personal_id_request_age_over_18_and_portrait_or_portrait_equivalence" to "만 18세 이상 + (본인 사진 또는 본인 사진 확인)",
    "eu_personal_id_request_age_over_18_zkp" to "18세 이상 (ZKP)",
    "eu_personal_id_request_all_data_elements" to "모든 정보 항목",
    "eu_personal_id_request_mandatory_data_elements" to "필수 정보 항목",
    "eu_personal_id_request_name_and_portrait" to "이름 + 본인 사진",
    "eu_personal_id_request_name_and_portrait_equivalence" to "이름 + 본인 사진 확인",
    "eu_personal_id_request_name_and_portrait_or_portrait_equivalence" to "이름 + (본인 사진 또는 본인 사진 확인)",
    "id_pass_request_age_over_18" to "18세 이상",
    "id_pass_request_age_over_18_and_portrait" to "만 18세 이상 + 초상",
    "id_pass_request_age_over_18_and_portrait_equivalence" to "만 18세 이상 + 본인 사진 확인",
    "id_pass_request_age_over_18_and_portrait_or_portrait_equivalence" to "만 18세 이상 + (증명사진 또는 그에 상응하는 사진)",
    "id_pass_request_age_over_18_zkp" to "18세 이상 (ZKP)",
    "id_pass_request_age_over_21" to "21세 이상",
    "id_pass_request_age_over_21_and_portrait" to "만 21세 이상 + 초상",
    "id_pass_request_age_over_21_zkp" to "21세 이상 (ZKP)",
    "id_pass_request_all_data_elements" to "모든 데이터 요소",
    "id_pass_request_mandatory_data_elements" to "필수 데이터 요소",
    "multi_request_age_over_18_mdl_or_pid" to "mDL 또는 PID를 통한 18세 이상 및 거래",
    "multi_request_mdl_and_photoid" to "mDL 및 PhotoID",
    "multi_request_mdl_or_photoid" to "mDL 또는 PhotoID",
    "multi_request_payment_and_age_over_18" to "결제 및 18세 이상",
    "photo_id_attribute_administrative_number" to "행정 번호",
    "photo_id_attribute_age_in_years" to "만 나이",
    "photo_id_attribute_birth_city" to "출생 도시",
    "photo_id_attribute_birth_country" to "출생 국가",
    "photo_id_attribute_birth_state" to "출생 주",
    "photo_id_attribute_date_of_birth" to "생년월일",
    "photo_id_attribute_date_of_expiry" to "만료일",
    "photo_id_attribute_date_of_issue" to "발급일",
    "photo_id_attribute_document_number" to "문서 번호",
    "photo_id_attribute_dtc_vc_version" to "DTC-VC 버전",
    "photo_id_attribute_emrtd_dg1" to "eMRTD DG1",
    "photo_id_attribute_emrtd_dg10" to "eMRTD DG10",
    "photo_id_attribute_emrtd_dg11" to "eMRTD DG11",
    "photo_id_attribute_emrtd_dg12" to "eMRTD DG12",
    "photo_id_attribute_emrtd_dg13" to "eMRTD DG13",
    "photo_id_attribute_emrtd_dg14" to "eMRTD DG14",
    "photo_id_attribute_emrtd_dg15" to "eMRTD DG15",
    "photo_id_attribute_emrtd_dg16" to "eMRTD DG16",
    "photo_id_attribute_emrtd_dg2" to "eMRTD DG2",
    "photo_id_attribute_emrtd_dg3" to "eMRTD DG3",
    "photo_id_attribute_emrtd_dg4" to "eMRTD DG4",
    "photo_id_attribute_emrtd_dg5" to "eMRTD DG5",
    "photo_id_attribute_emrtd_dg6" to "eMRTD DG6",
    "photo_id_attribute_emrtd_dg7" to "eMRTD DG7",
    "photo_id_attribute_emrtd_dg8" to "eMRTD DG8",
    "photo_id_attribute_emrtd_dg9" to "eMRTD DG9",
    "photo_id_attribute_emrtd_sod" to "eMRTD SOD",
    "photo_id_attribute_family_name" to "성",
    "photo_id_attribute_family_name_latin1" to "성",
    "photo_id_attribute_family_name_viz" to "성 (VIZ)",
    "photo_id_attribute_given_name_viz" to "이름 (VIZ)",
    "photo_id_attribute_given_names" to "이름",
    "photo_id_attribute_given_names_latin1" to "이름",
    "photo_id_attribute_issuing_authority" to "발급 기관",
    "photo_id_attribute_issuing_country" to "발행 국가",
    "photo_id_attribute_issuing_subdivision" to "발급 기관",
    "photo_id_attribute_name_at_birth" to "출생 시 이름",
    "photo_id_attribute_nationality" to "국적",
    "photo_id_attribute_person_id" to "개인 ID",
    "photo_id_attribute_photo_of_holder" to "소지자 사진",
    "photo_id_attribute_place_of_birth" to "출생지",
    "photo_id_attribute_portrait_capture_date" to "사진 촬영일",
    "photo_id_attribute_resident_address" to "거주 주소",
    "photo_id_attribute_resident_city" to "거주 도시",
    "photo_id_attribute_resident_city_latin1" to "거주 도시",
    "photo_id_attribute_resident_country" to "거주 국가",
    "photo_id_attribute_resident_house_number" to "거주지 건물 번호",
    "photo_id_attribute_resident_postal_code" to "거주 우편 번호",
    "photo_id_attribute_resident_state" to "거주지 주",
    "photo_id_attribute_resident_street" to "거주지 도로명",
    "photo_id_attribute_sex" to "성별",
    "photo_id_attribute_travel_document_mrz" to "여행 서류 MRZ",
    "photo_id_attribute_travel_document_number" to "여행 서류 번호",
    "photo_id_attribute_travel_document_type" to "여행 서류 유형",
    "photo_id_attribute_year_of_birth" to "생년",
    "photo_id_description_administrative_number" to "감사 관리 또는 기타 목적을 위해 사진 ID 발급 기관에서 부여한 번호",
    "photo_id_description_age_in_years" to "문서 소지자의 나이",
    "photo_id_description_birth_city" to "사진 ID 소지자가 태어난 행정 구역, 시, 읍 또는 마을",
    "photo_id_description_birth_country" to "사진 신분증 소지자가 태어난 국가 (ISO 3166-1에 명시된 알파-2 국가 코드 형식)",
    "photo_id_description_birth_state" to "사진 신분증 소지자가 태어난 주, 도, 구역 또는 지역",
    "photo_id_description_date_of_birth" to "문서 소지자의 출생 일, 월, 년도. 알 수 없는 경우, 대략적인 생년월일",
    "photo_id_description_date_of_expiry" to "문서 만료일",
    "photo_id_description_date_of_issue" to "문서 발급일",
    "photo_id_description_document_number" to "발급 기관이 지정하거나 계산한 번호",
    "photo_id_description_dtc_vc_version" to "DTC-VC 정의 버전",
    "photo_id_description_emrtd_dg1" to "데이터 그룹 1: 생체 정보 (MRZ에 기록된 데이터)",
    "photo_id_description_emrtd_dg10" to "데이터 그룹 10: 물질 특성",
    "photo_id_description_emrtd_dg11" to "데이터 그룹 11: 추가 개인 정보",
    "photo_id_description_emrtd_dg12" to "데이터 그룹 12: 추가 문서 정보",
    "photo_id_description_emrtd_dg13" to "데이터 그룹 13: 선택 정보",
    "photo_id_description_emrtd_dg14" to "데이터 그룹 14: 보안 옵션",
    "photo_id_description_emrtd_dg15" to "데이터 그룹 15: 능동 인증 공개 키 정보",
    "photo_id_description_emrtd_dg16" to "데이터 그룹 16: 통지 대상자",
    "photo_id_description_emrtd_dg2" to "데이터 그룹 2: 참조 초상화 (인코딩된 얼굴)",
    "photo_id_description_emrtd_dg3" to "데이터 그룹 3: 인코딩된 지문",
    "photo_id_description_emrtd_dg4" to "데이터 그룹 4: 인코딩된 눈",
    "photo_id_description_emrtd_dg5" to "데이터 그룹 5: 표시된 초상화",
    "photo_id_description_emrtd_dg6" to "데이터 그룹 6: 향후 사용을 위해 예약됨",
    "photo_id_description_emrtd_dg7" to "데이터 그룹 7: 표시된 서명 또는 통상적인 표식",
    "photo_id_description_emrtd_dg8" to "데이터 그룹 8: 데이터 특성",
    "photo_id_description_emrtd_dg9" to "데이터 그룹 9: 구조 특성",
    "photo_id_description_emrtd_sod" to "eMRTD 문서 보안 객체의 이진 데이터",
    "photo_id_description_family_name" to "문서 소지자의 성, 이름 또는 기본 식별자",
    "photo_id_description_family_name_latin1" to "문서 소지자의 성, 가족 이름 또는 기본 식별자",
    "photo_id_description_family_name_viz" to "ICAO 9303의 VIZ(육안 검사 영역)에 정의된 성",
    "photo_id_description_given_name_viz" to "ICAO 9303의 VIZ(육안 검사 영역)에 정의된 이름",
    "photo_id_description_given_names" to "문서 소지자의 이름(들), 다른 이름(들) 또는 보조 식별자",
    "photo_id_description_given_names_latin1" to "문서 소지자의 이름(들), 기타 이름(들) 또는 보조 식별자",
    "photo_id_description_issuing_authority" to "발급 기관명",
    "photo_id_description_issuing_country" to "ISO 3166-1에 정의된 발급 기관 국가/지역의 Alpha-2 국가 코드",
    "photo_id_description_issuing_subdivision" to "모바일 전자신분증을 발급했거나 발급 기관이 위치한 ISO 3166-2에 정의된 하위 지역 코드",
    "photo_id_description_name_at_birth" to "소지자의 출생 시 이름(들)",
    "photo_id_description_nationality" to "문서 소지자의 국적",
    "photo_id_description_person_id" to "사진 신분증 소지자의 개인 식별자",
    "photo_id_description_photo_of_holder" to "문서 소지자의 사진",
    "photo_id_description_place_of_birth" to "문서 소지자가 태어난 국가 및 시/군 또는 주/도",
    "photo_id_description_portrait_capture_date" to "인물 사진 촬영일",
    "photo_id_description_resident_address" to "문서 소지자가 거주하거나 연락받을 수 있는 장소 (도로명/번지, 시/군 등)",
    "photo_id_description_resident_city" to "소지자가 거주하는 시/군 (또는 이에 상응하는 지역)",
    "photo_id_description_resident_city_latin1" to "소지자가 거주하는 도시/지자체(또는 이에 상응하는 지역)",
    "photo_id_description_resident_country" to "문서 소지자가 거주하는 국가",
    "photo_id_description_resident_house_number" to "사진 ID 소지자가 현재 거주하는 번지수 (접두사 또는 접미사 포함)",
    "photo_id_description_resident_postal_code" to "문서 소지자의 우편 번호",
    "photo_id_description_resident_state" to "사진 ID 소지자가 거주하는 주/도/구역",
    "photo_id_description_resident_street" to "사진 ID 소지자가 현재 거주하는 도로명",
    "photo_id_description_sex" to "문서 소지자의 성별",
    "photo_id_description_travel_document_mrz" to "실제 문서에 인쇄된 텍스트 형태의 기계 판독 영역",
    "photo_id_description_travel_document_number" to "사진 ID와 연결된 여행 서류의 번호 (여행 서류와 관련되거나 파생된 경우)",
    "photo_id_description_travel_document_type" to "원본 문서의 종류 식별자 (여행 서류와 관련되거나 파생된 경우)",
    "photo_id_description_year_of_birth" to "문서 소지자의 출생 연도",
    "photo_id_request_age_over_18" to "18세 이상",
    "photo_id_request_age_over_18_and_portrait" to "18세 이상 + 초상",
    "photo_id_request_age_over_18_and_portrait_equivalence" to "만 18세 이상 + 본인 사진 확인",
    "photo_id_request_age_over_18_and_portrait_or_portrait_equivalence" to "만 18세 이상 + (본인 사진 또는 본인 사진 확인)",
    "photo_id_request_age_over_18_zkp" to "18세 이상 (ZKP)",
    "photo_id_request_all_data_elements" to "모든 데이터 요소",
    "photo_id_request_mandatory_data_elements" to "필수 데이터 요소",
    "vaccination_attribute_birth_day" to "출생 일",
    "vaccination_attribute_birth_month" to "출생 월",
    "vaccination_attribute_birth_year" to "출생 연도",
    "vaccination_attribute_covid19_first_vaccination" to "RA01 1차 접종",
    "vaccination_attribute_covid19_second_vaccination" to "RA01 2차 접종",
    "vaccination_attribute_covid19_test" to "코로나19 검사 기록",
    "vaccination_attribute_covid19_vaccinated" to "코로나19 예방접종",
    "vaccination_attribute_date_of_birth" to "생년월일",
    "vaccination_attribute_facial_image" to "얼굴 이미지",
    "vaccination_attribute_family_name" to "성",
    "vaccination_attribute_family_name_initial" to "성 이니셜",
    "vaccination_attribute_given_name" to "이름",
    "vaccination_attribute_given_name_initial" to "이름 이니셜",
    "vaccination_attribute_id_with_drivers_license_number" to "운전면허증 번호가 있는 신분증",
    "vaccination_attribute_id_with_passport_number" to "여권 번호가 있는 신분증",
    "vaccination_attribute_safe_entry_leisure" to "안전 출입 표시",
    "vaccination_attribute_sex" to "성별",
    "vaccination_attribute_yellow_fever_vaccinated" to "황열병 예방접종",
    "vaccination_description_birth_day" to "본인 생일",
    "vaccination_description_birth_month" to "본인 생월",
    "vaccination_description_birth_year" to "본인 생년",
    "vaccination_description_covid19_first_vaccination" to "코로나19 - 1차 접종 데이터",
    "vaccination_description_covid19_second_vaccination" to "코로나19 - 2차 접종 데이터",
    "vaccination_description_covid19_test" to "소지자가 코로나19 음성 판정을 받았음을 증명",
    "vaccination_description_covid19_vaccinated" to "소지자가 코로나19 예방접종을 완료했음을 증명",
    "vaccination_description_date_of_birth" to "본인 생년월일",
    "vaccination_description_facial_image" to "본인 사진",
    "vaccination_description_family_name" to "본인 성",
    "vaccination_description_family_name_initial" to "본인 성 첫 글자",
    "vaccination_description_given_name" to "본인 이름",
    "vaccination_description_given_name_initial" to "본인 이름 첫 글자",
    "vaccination_description_id_with_drivers_license_number" to "운전면허 번호를 이용한 소지자 식별 고유 정보",
    "vaccination_description_id_with_passport_number" to "여권 번호를 이용한 소지자 식별 고유 정보",
    "vaccination_description_safe_entry_leisure" to "소지자가 여가 활동 관련 안전 입국 요건을 충족했음을 증명 (예방접종, 회복 또는 음성 검사 여부는 비공개)",
    "vaccination_description_sex" to "성별",
    "vaccination_description_yellow_fever_vaccinated" to "소지자가 황열병 예방접종을 완료했음을 증명",
    "vehicle_registration_attribute_basic_vehicle_info" to "기본적인 차량 정보",
    "vehicle_registration_attribute_issue_date" to "발급일",
    "vehicle_registration_attribute_registration_holder" to "차량 등록 소유자 정보",
    "vehicle_registration_attribute_registration_info" to "차량 등록 정보",
    "vehicle_registration_attribute_vin" to "차대번호",
    "vehicle_registration_description_basic_vehicle_info" to "이 데이터 요소에는 기본적인 차량 정보가 포함됩니다.",
    "vehicle_registration_description_issue_date" to "문서 발급일",
    "vehicle_registration_description_registration_holder" to "이 데이터 요소는 등록 증명서 소지자를 식별합니다.",
    "vehicle_registration_description_registration_info" to "이 데이터 요소에는 UN/EU 요소(A 및 H)를 포함한 일반적인 차량 등록 정보가 포함됩니다.",
    "vehicle_registration_description_vin" to "차량 제조사에서 정의한 차대번호"
)
